module.exports = __webpack_public_path__ + "static/img/thumb_7.feaf090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_7.png
// module id = PXnt
// module chunks = 0